<!-- 
<div style="overflow:hidden;">
    <div class="home_data row">
        <div class="home_image col-md-6">
            <img src="assets/websites.png" style="width:100%;">
            <div class="box_under_image">
                <div style="display: flex;align-items: center;">
                    <img src="assets/profile_filled.png" style="height: 30px;width: 30px;margin-right: 15px;">
                    <div style="padding: 10px;background-color: #ff6100;border-radius: 30px;color: white;"><span style="font-family: Montserrat;font-size: 13px;font-weight: 600 ;">Can sharkify Build E-Commerce Website</span></div>
                </div>
                <div style="display: flex;align-items: center;margin: 10px 0px 0px 20px;">
                    <img src="assets/profile_filled.png" style="height: 30px;width: 30px;margin-right: 15px;">
                    <div style="padding: 10px;background-color: #ff6100;border-radius: 30px;color: white;"><span style="font-family: Montserrat;font-size: 13px;font-weight: 600 ;">Yes We Can Build it.</span></div>
                </div>
            </div>
        </div>
        <div class="home_header col-md-6">
            <h1 class="home_header">SuperCharge Your<br>Marketing Strategy !<br></h1>
              <span style="color:#ff6100;">Sharkify.ai</span> make<br>it simple
              <div style="font-size: 18px;padding: 20px 0px;">
                <button class="trial_button" routerLink="/Home" (click)="scrollTo('SocialMediaPlans')">Start 7-days Free Trail</button>
              </div>
        </div>
    </div>
</div> -->
<div class="container">
    <div class="left-section">
        <div class="image-section">
            <img src="assets/websites.png" loading="lazy" alt="Sharkify" class="background-image" />

            <div class="pop-up">
                <div class="message">
                    <div class="icon" style="background-color: black;">
                        <i class="fa-solid fa-user" style="color: white;"></i>
                    </div>
                    <span class="jumping-dots" id="dot1">
                        <span class="dot-1">.</span>
                        <span class="dot-2">.</span>
                        <span class="dot-3">.</span>
                    </span>
                    <div class="text" hidden>
                        Can Sharkify Build <br> <span class="highlight">E - Commerce</span> Website?
                    </div>
                </div>

                <div class="message" id="message2">
                    <!-- <i class="fa-thin fa-l" style="padding-left: 10px; padding-right: 4px; font-size: 17px;"></i> -->
                    <div class="icon" style="margin-right: 8px; background-color: #ff6e06;">
                        <i class="fa-solid fa-user" style="color: white;"></i>
                    </div>
                    <span class="jumping-dots" id="dot2">
                        <span class="dot-1">.</span>
                        <span class="dot-2">.</span>
                        <span class="dot-3">.</span>
                    </span>
                    <div class="text" hidden>
                        Yes, We Can <span class="highlight">Build</span> it.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="right-section">
        <div>
            <p>Supercharge Your Marketing Strategy!</p>
            <p><b style="color: #ff6200;">Sharkify.ai</b> makes it simple!</p>
        </div>
        <div style="width: 100%;">
            <button class="trial-btn"  routerLink="/Home" (click)="scrollTo('SocialMediaPlans')"> Start 7-Day Free Trial</button>
        </div>
        
    </div>
</div>
